import React, { useEffect, useState } from "react";
import SizeIcon from "../../assets/Icons/SizeIcon";
import GlassIcon from "../../assets/Icons/GlassIcon";
import VarientIcon from "../../assets/Icons/VarientIcon";
import ArrowLeftIcon from "../../assets/Icons/ArrowLeftIcon";
import { getBase64FromUrl, VARIENTS } from "../../utils/global";
import ColorPickerIcon from "../../assets/Icons/ColorPickerIcon";
import { useDraggable } from "../../context/DrabbleContext";
import EditIcon from "../../assets/Icons/EditIcon";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import { ReactComponent as UploadIcon } from "../../assets/Icons/uploadIcon.svg";
import FileUploadPopup from "../Auth/FileUploadPopup";
import { useParams } from "react-router-dom";
import { v7 as uuidv7 } from "uuid";
import axios from "axios";
import { BASE_URL } from "../../utils/code";
import { toast } from "react-toastify";

const sideBarConfig = [
  {
    id: 1,
    icon: GlassIcon,
    label: "Touch Panel Type",
    name: "frame",
  },

  {
    id: 2,
    icon: ColorPickerIcon,
    label: "Color",
    name: "color",
  },
  {
    id: 3,
    icon: SizeIcon,
    label: "Size",
    name: "size",
  },
  {
    id: 4,
    icon: VarientIcon,
    label: "Variant",
    name: "varients",
  },
];

const glasssModules = [
  {
    id: 1,
    label: "2 Module",
    value: 1,
  },
  {
    id: 2,
    label: "4 Module",
    value: 2,
  },

  {
    id: 3,
    label: "6 Module",
    value: 3,
  },
  {
    id: 4,
    label: "8 Module",
    value: 4,
  },
];

const archalicModules = [
  {
    id: 1,
    label: "2 Module",
    value: 1,
  },
  {
    id: 2,
    label: "4 Module",
    value: 2,
  },

  {
    id: 3,
    label: "6 Module",
    value: 3,
  },
  {
    id: 4,
    label: "8 Module",
    value: 4,
  },
  {
    id: 5,
    label: "12 Module",
    value: 6,
  },

  {
    id: 6,
    label: "18 Module",
    value: 9,
  },
];

const touchPannelProModules = [
  {
    id: 6,
    label: "Touch Pannel Pro",
    value: 10,
  },
];

const R_Menu_CONFIG = {
  frame: [
    {
      id: 1,
      label: "Glass",
      value: "glass",
    },
    {
      id: 2,
      label: "Acrylic",
      value: "acrylic",
    },
    {
      id: 3,
      label: "Modular Touch Switch",
      value: "module_touch_switch",
    },

    {
      id: 4,
      label: "Touch panel pro",
      value: "touch_panel_pro",
    },
    {
      id: 5,
      label: "Laminate",
      value: "laminate_varient",
    },
  ],
  size: [],
  varients: [],
  color: [
    {
      id: 1,
      label: "Black",
      value: "#171411",
    },
    {
      id: 2,
      label: "White",
      value: "white",
    },
  ],
};

function TouchSlider({ design, setDesign, handleSaveContent }) {
  const [selected, setSelected] = useState();
  const [rMeenuConfig, setRMenuConfig] = useState(R_Menu_CONFIG);
  const [fileUploadOpen, setFileUploadPopup] = useState(false);

  const { handleDragStart, handleTouchStart, setContent, logo, setLogo, assignDefaultNumberIcons } = useDraggable();

  const params = useParams();
  const checkIsDisable = (key) => {
    if (key == "color") {
      if (!design?.frame) {
        return true;
      }
    }

    if (key == "size") {
      if (!design?.frame || !design?.color) {
        return true;
      }

      if (
        design?.frame == "module_touch_switch" ||
        design?.frame == "touch_panel_pro"
      ) {
        return true;
      }
    }

    if (key == "varients") {
      if (!design?.frame || !design.size || !design?.color) {
        return true;
      }
    }

    return false;
  };

  const handleSetDesign = (data) => {
    let input = {
      ...design,
      [selected]: data?.value,
    };

    if (selected == "frame" && data?.value == "module_touch_switch") {
      input = {
        ...input,
        size: 1,
      };
    }

    if (selected == "frame" && data?.value == "touch_panel_pro") {
      input = {
        ...input,
        size: 10,
      };
    }

    setDesign(input);

    if (selected == "frame") {
      setContent([
        {
          key: 1,
          data: [],
          id: uuidv7(),
        },
      ]);
    }

    if (selected == "size" && data?.value == 6) {
      setContent([
        {
          key: 1,
          data: [],
          id: uuidv7(),
        },
        {
          key: 2,
          data: [],
          id: uuidv7(),
        },
      ]);
      return;
    }

    if (selected == "size" && data?.value == 9) {
      setContent([
        {
          key: 1,
          data: [],
          id: uuidv7(),
        },
        {
          key: 2,
          data: [],
          id: uuidv7(),
        },
        {
          key: 3,
          data: [],
          id: uuidv7(),
        },
      ]);
      return;
    }

    if (selected == "size") {
      setContent([
        {
          key: 1,
          data: [],
          id: uuidv7(),
        },
      ]);
    }
  };

  useEffect(() => {
    const input = {
      ...rMeenuConfig,
    };

    if (design?.size || design?.frame) {
      let varient = VARIENTS[`${design?.size}_${design?.frame}`];
      input["varients"] = varient;
    }

    if (design?.frame) {
      let modules = [];
      if (design?.frame == "glass") {
        modules = glasssModules;
      }

      if (design?.frame == "acrylic" || design?.frame == "laminate_varient") {
        modules = archalicModules;
      }

      if (design?.frame == "touch_panel_pro") {
        modules = touchPannelProModules;
      }

      input["size"] = modules;
    }

    setRMenuConfig(input);
  }, [design]);

  // useEffect(() => {
  //   if (!design?.frame) {
  //     return;
  //   }

  //   const modules = design?.frame == "glass" ? glasssModules : archalicModules;

  //   setRMenuConfig({
  //     ...rMeenuConfig,
  //     size: modules,
  //   });
  // }, [design?.frame]);

  const rendersliderContent = () => {
    if (!selected) {
      return null;
    }

    const data = rMeenuConfig[selected];

    return (
      <div
        className="absolute -right-[200px] top-0 w-[200px]"
        style={{
          height: "calc(100vh - 4rem)",
          boxShadow: "0 0 5px #CCC",
          overflowY: "scroll",
        }}
      >
        <div
          className="px-5 py-3 cursor-pointer"
          onClick={() => setSelected(0)}
        >
          <ArrowLeftIcon />
        </div>
        <ul>
          {data?.map((item, index) => {
            const isActive = design[selected] == item?.value;

            return (
              <li
                className={`text-center flex justify-center text-sm py-3 cursor-pointer hover:bg-[#EEE] ${
                  isActive && "bg-[#EEE]"
                }`}
                key={index}
                onClick={() => handleSetDesign(item)}
                onDragStart={(event) => {
                  if (selected === "varients") {
                    handleDragStart(event, item);
                  }
                }}
                onTouchStart={(event) => {
                  if (selected === "varients") {
                    event.currentTarget.classList.add('touch-dragging');
                    handleTouchStart(event, item);
                  }
                }}
                draggable={selected === "varients"}
              >
                {item.label}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const handleDeleteLogo = async () => {
    try {
      // Show deletion in progress toast
      toast.info("Deleting logo...");
      
      // Call the API to delete images from S3
      const response = await axios.post(
        `${BASE_URL}/api/projects/delete-touch-image/${params.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // If deletion is successful, update local state
      if (response.data.success) {
        setLogo({
          image: null,
          image2: null,
          image3: null,
        });
        toast.success(response.data.message || "Logo deleted successfully");
      } else {
        // If there's an error message in the response
        toast.error(response.data.message || "Failed to delete logo");
      }
    } catch (error) {
      console.error("Delete logo error:", error);
      toast.error("Failed to delete logo from server");
      // Still clear the local state so it appears deleted to the user
      setLogo({
        image: null,
        image2: null,
        image3: null,
      });
    }
  };

  return (
    <div
      className="w-[90px] mt-24 pt-4 bg-slate-200 relative"
      style={{
        height: "calc(100vh - 6rem)",
      }}
    >
      <div className="flex flex-col gap-5">
        {sideBarConfig?.map((item) => {
          const Icon = item.icon;

          return (
            <div
              className="flex flex-col items-center cursor-pointer"
              key={item.id}
              onClick={() => {
                if (checkIsDisable(item.name)) return;
                setSelected(item.name);
              }}
              style={{
                color: checkIsDisable(item.name) ? "#AAA" : null,
              }}
            >
              <Icon />
              <p className="text-sm text-center">{item.label}</p>
            </div>
          );
        })}
        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => {
            setFileUploadPopup(true);
          }}
        >
          <UploadIcon />
          <p className="text-sm text-center">Upload Logo</p>
        </div>

        {(logo?.image || logo?.image2 || logo?.image3) && (
          <div
            className="flex flex-col items-center cursor-pointer"
            onClick={handleDeleteLogo}
            style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
          >
            <div style={{ width: '24px', height: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <DeleteIcon />
            </div>
            <p className="text-sm text-center">Delete Logo</p>
          </div>
        )}

        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => {
            assignDefaultNumberIcons();
          }}
          title="Assign default number icons to switches (1, 2, 3, ...)"
        >
          <div className="w-6 h-6 flex items-center justify-center border border-gray-600 rounded">
            <span className="text-xs font-bold">#</span>
          </div>
          <p className="text-sm text-center">Auto Number</p>
        </div>

        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => {
            handleSaveContent();
          }}
        >
          <EditIcon />
          <p className="text-sm">Save</p>
        </div>
      </div>
      {rendersliderContent()}
      {fileUploadOpen && params.id && (
        <FileUploadPopup
          fileUploadOpen={fileUploadOpen}
          onClose={() => {
            setFileUploadPopup(false);
          }}
          id={params.id}
          onSuccess={async (path) => {
            setLogo({
              image: await getBase64FromUrl(path?.image),
              image2: await getBase64FromUrl(path?.image2),
              image3: await getBase64FromUrl(path?.image3),
            });
          }}
        />
      )}
    </div>
  );
}

export default TouchSlider;
